import React, { useEffect, useState } from 'react'
import './MAccount.scss'
import ACCOUNTBG from '../../assets/images/Account/Mobile/ACCOUNTBG.svg'
import { Link, useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import MSettings from './MSettings/MSettings'
import { useTranslation } from 'react-i18next'
import { useStateValue } from '../../store/state'
import Notifications from '../../components/Notifications/Notifications'
import { NOTIFICATION } from '../../store/Header/Action'

function MAccount() {
  const [showSettings, setShowSettings] = useState(false)
  const [notificationcount, setnotificationcount] = useState([])
  const [notificationFetched, setNotificationFetched] = useState(false); // Track if notifications have been fetched

  const { t } = useTranslation()
  const [{ NOTIFICATION__DATA }, dispatch] = useStateValue();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (localStorage.getItem('userdata') == undefined) {
      history.replace("/login", { from: location.pathname });
    }
  }, [localStorage.getItem('userdata')])

  useEffect(() => {
    let TOKEN = localStorage.getItem("token")
    let USERID = localStorage.getItem("userid")
    setInterval(() => {
      if (!notificationFetched) { // Check if notifications have already been fetched
        NOTIFICATION(dispatch, USERID, TOKEN);
        setNotificationFetched(true); // Set flag to true after fetching
      }
    }, 20000)
  }, [])

  // useEffect(() => {
  //   let TOKEN = localStorage.getItem("token")
  //   let USERID = localStorage.getItem("userid")
  //   NOTIFICATION(dispatch, USERID, TOKEN)
  // }, [])

  const signout = (e) => {
    e.preventDefault();
    const storedLanguage = localStorage.getItem('storeid')
    localStorage.clear()

    //return storedLanguage ? parseInt(storedLanguage, 10):2;
    localStorage.setItem('storeid', parseInt(storedLanguage, 10) || 2)
    navigator.serviceWorker.getRegistrations().then(function (registrations) {
      for (const registration of registrations) {
        registration.unregister();
      }
    });

    // Clear cache (optional)
    caches.keys().then(function (cacheNames) {
      cacheNames.forEach(function (cacheName) {
        caches.delete(cacheName);
      });
    });

    // Reload the page (optional)
    // window.location.reload(true);

    // Redirect to home page after short delay
    setTimeout(() => {
      window.location.href = '/';
    }, 100); // slight delay to ensure unregister completes
  }
  useEffect(() => {
    const uniqueNotifications = new Map(); // Use a Map to track unique notifications

    let data = NOTIFICATION__DATA?.filter(el => {
      // Exclude specific categories and action data
      if (el?.category === "add_to_cart" || el?.category === "remove_from_cart" ||
        el?.action_data.toLowerCase().includes('added') ||
        el?.action_data.toLowerCase().includes('deleted')) {
        return false;
      }

      // Check if the notification is already in the Map
      if (!uniqueNotifications.has(el.order_id)) { // Assuming order_id is unique
        uniqueNotifications.set(el.order_id, el); // Add to Map
        return true; // Keep this notification
      }
      return false; // Skip duplicates
    }).slice(0, 100);
    data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

    setnotificationcount(data);
  }, [NOTIFICATION__DATA])
  return (
    showSettings ? <MSettings setShowSettings={setShowSettings} />
      :
      <div className='MACCOUNT'>
        <h5>{t("Account")}</h5>

        <div className='MACCOUNT__TOP'>
          <img src={ACCOUNTBG} alt="" />

          <div className='MACCOUNT__TOP__USER'>
            <p className='USER__HELLO'>{t("HELLO")},</p>
            <p className='USER__NAME'>{JSON.parse(localStorage.getItem('userdata'))?.extension_attributes?.trade_name}</p>


            <p className='USER__EMAIL'>{t("EMAIL")}: {localStorage.getItem('user')}</p>
          </div>

          <div className='MACCOUNT__TOP__ICONMENU'>
            <p className='ICONMENU__ORDER'>
              <Link to="/myorder">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                  <g clip-path="url(#clip0_1_15144)">
                    <path d="M19 6.92383H17C17 4.16383 14.76 1.92383 12 1.92383C9.24 1.92383 7 4.16383 7 6.92383H5C3.9 6.92383 3 7.82383 3 8.92383V20.9238C3 22.0238 3.9 22.9238 5 22.9238H19C20.1 22.9238 21 22.0238 21 20.9238V8.92383C21 7.82383 20.1 6.92383 19 6.92383ZM12 3.92383C13.66 3.92383 15 5.26383 15 6.92383H9C9 5.26383 10.34 3.92383 12 3.92383ZM19 20.9238H5V8.92383H19V20.9238ZM12 12.9238C10.34 12.9238 9 11.5838 9 9.92383H7C7 12.6838 9.24 14.9238 12 14.9238C14.76 14.9238 17 12.6838 17 9.92383H15C15 11.5838 13.66 12.9238 12 12.9238Z" fill="white" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_15144">
                      <rect width="24" height="24" fill="white" transform="translate(0 0.923828)" />
                    </clipPath>
                  </defs>
                </svg>
                <span>{t("MYORDER")}</span></Link>
            </p>
            <p className='ICONMENU__FINANCE'>
              <Link to="myfinance">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                  <g clip-path="url(#clip0_1_15150)">
                    <path d="M12 2.92383C6.48 2.92383 2 7.40383 2 12.9238C2 18.4438 6.48 22.9238 12 22.9238C17.52 22.9238 22 18.4438 22 12.9238C22 7.40383 17.52 2.92383 12 2.92383ZM12 20.9238C7.59 20.9238 4 17.3338 4 12.9238C4 8.51383 7.59 4.92383 12 4.92383C16.41 4.92383 20 8.51383 20 12.9238C20 17.3338 16.41 20.9238 12 20.9238ZM12.31 12.0638C10.54 11.6138 9.97 11.1238 9.97 10.3938C9.97 9.55383 10.76 8.96383 12.07 8.96383C13.45 8.96383 13.97 9.62383 14.01 10.6038H15.72C15.67 9.26383 14.85 8.03383 13.23 7.63383V5.92383H10.9V7.61383C9.39 7.93383 8.18 8.91383 8.18 10.4238C8.18 12.2138 9.67 13.1138 11.84 13.6338C13.79 14.0938 14.18 14.7838 14.18 15.5038C14.18 16.0338 13.79 16.8938 12.08 16.8938C10.48 16.8938 9.85 16.1738 9.76 15.2538H8.04C8.14 16.9538 9.4 17.9138 10.9 18.2238V19.9238H13.24V18.2538C14.76 17.9638 15.96 17.0938 15.97 15.4838C15.96 13.2838 14.07 12.5238 12.31 12.0638Z" fill="white" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_15150">
                      <rect width="24" height="24" fill="white" transform="translate(0 0.923828)" />
                    </clipPath>
                  </defs>
                </svg>
                <span>{t("MYFINANCE")}</span>
              </Link>
            </p>
            <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRightNotification" aria-labelledby="offcanvasRightNotificationLabel">
              <div class="offcanvas-header">
                {window.innerWidth <= 912 && <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" data-bs-dismiss="offcanvas">
                  <g clip-path="url(#clip0_1_15279)">
                    <path d="M17.5098 3.86961L15.7298 2.09961L5.83984 11.9996L15.7398 21.8996L17.5098 20.1296L9.37984 11.9996L17.5098 3.86961Z" fill="#1C304A" fill-opacity="0.52" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_15279">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>}
                <h5 id="offcanvasRightNotificationLabel">{t("YOURNOTIFICATIONS")}</h5>
                {window.innerWidth > 912 && <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" data-bs-dismiss="offcanvas">
                  <g clip-path="url(#clip0_1_15356)">
                    <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#1C304A" fill-opacity="0.52" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_15356">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>}
              </div>
              <div class="offcanvas-body">
                <Notifications NOTIFICATION__DATA={NOTIFICATION__DATA} dispatch={dispatch} />
              </div>
            </div>
            <p className='ICONMENU__NOTIFICATIONS' data-bs-toggle="offcanvas" data-bs-target="#offcanvasRightNotification" aria-controls="offcanvasRightNotification">
              <small>
                {/* {NOTIFICATION__DATA?.length > 99 ? <span>99<strong>+</strong></span> : NOTIFICATION__DATA?.length} */}
                {notificationcount?.length > 0 ? <span>{notificationcount?.length}</span> : null}

              </small>
              <Link>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                  <g clip-path="url(#clip0_1_15155)">
                    <path d="M12 22.9238C13.1 22.9238 14 22.0238 14 20.9238H10C10 22.0238 10.9 22.9238 12 22.9238ZM18 16.9238V11.9238C18 8.85383 16.37 6.28383 13.5 5.60383V4.92383C13.5 4.09383 12.83 3.42383 12 3.42383C11.17 3.42383 10.5 4.09383 10.5 4.92383V5.60383C7.64 6.28383 6 8.84383 6 11.9238V16.9238L4 18.9238V19.9238H20V18.9238L18 16.9238ZM16 17.9238H8V11.9238C8 9.44383 9.51 7.42383 12 7.42383C14.49 7.42383 16 9.44383 16 11.9238V17.9238Z" fill="white" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_15155">
                      <rect width="24" height="24" fill="white" transform="translate(0 0.923828)" />
                    </clipPath>
                  </defs>
                </svg>
                <span>{t("NOTIFICATIONS")}
                </span>
              </Link>
            </p>
          </div>

        </div>

        <div className='MYACCOUNT__MENU'>
          <div className='MACCOUNT__MENU__ONE'>
            <p>
              <Link to="/myaccount/myprofile">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <g clip-path="url(#clip0_1_15169)">
                    <path d="M12 6C13.1 6 14 6.9 14 8C14 9.1 13.1 10 12 10C10.9 10 10 9.1 10 8C10 6.9 10.9 6 12 6ZM12 16C14.7 16 17.8 17.29 18 18H6C6.23 17.28 9.31 16 12 16ZM12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" fill="#323232" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_15169">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <span>{t("MYPROFILE")}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <g clip-path="url(#clip0_1_15171)">
                    <path d="M9.99984 6L8.58984 7.41L13.1698 12L8.58984 16.59L9.99984 18L15.9998 12L9.99984 6Z" fill="#192739" fill-opacity="0.94" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_15171">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </Link>
            </p>
            <p>
              <Link to="/myaccount/deliveryaddress">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <g clip-path="url(#clip0_1_15175)">
                    <path d="M18.17 4.9097L17.1 3.8397L11.55 9.3897V10.4697H12.63L18.17 4.9097ZM16 2.7397L17.29 1.4497C17.4286 1.30941 17.5936 1.19802 17.7756 1.122C17.9576 1.04598 18.1528 1.00684 18.35 1.00684C18.5472 1.00684 18.7424 1.04598 18.9244 1.122C19.1064 1.19802 19.2714 1.30941 19.41 1.4497L20.56 2.5997C21.15 3.1897 21.15 4.1397 20.56 4.7197L19.88 5.3997L19.86 5.4197L19.28 5.9997L13.28 11.9997H10V8.7397L16 2.7397ZM13.72 2.1897L13.17 2.7397L11.9 4.0097C8.6 4.0597 6 6.6097 6 10.2097C6 12.5497 7.95 15.6497 12 19.3497C16.05 15.6497 18 12.5597 18 10.2097V10.1097L19.8 8.3097C19.93 8.9097 20 9.5497 20 10.2097C20 13.5297 17.33 17.4597 12 22.0097C6.67 17.4597 4 13.5297 4 10.2097C4 5.2297 7.8 2.0097 12 2.0097C12.58 2.0097 13.16 2.0697 13.72 2.1897Z" fill="#323232" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_15175">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <span>{t("DELIVERYADDRESS")}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <g clip-path="url(#clip0_1_15171)">
                    <path d="M9.99984 6L8.58984 7.41L13.1698 12L8.58984 16.59L9.99984 18L15.9998 12L9.99984 6Z" fill="#192739" fill-opacity="0.94" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_15171">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </Link>
            </p>
            <p>
              <Link to="/myaccount/usersetup">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <g clip-path="url(#clip0_1_15181)">
                    <path d="M9 12C10.93 12 12.5 10.43 12.5 8.5C12.5 6.57 10.93 5 9 5C7.07 5 5.5 6.57 5.5 8.5C5.5 10.43 7.07 12 9 12ZM9 7C9.83 7 10.5 7.67 10.5 8.5C10.5 9.33 9.83 10 9 10C8.17 10 7.5 9.33 7.5 8.5C7.5 7.67 8.17 7 9 7ZM9.05 17H4.77C5.76 16.5 7.47 16 9 16C9.11 16 9.23 16.01 9.34 16.01C9.68 15.28 10.27 14.68 10.98 14.2C10.25 14.07 9.56 14 9 14C6.66 14 2 15.17 2 17.5V19H9V17.5C9 17.33 9.02 17.16 9.05 17ZM16.5 14.5C14.66 14.5 11 15.51 11 17.5V19H22V17.5C22 15.51 18.34 14.5 16.5 14.5ZM17.71 12.68C18.47 12.25 19 11.44 19 10.5C19 9.12 17.88 8 16.5 8C15.12 8 14 9.12 14 10.5C14 11.44 14.53 12.25 15.29 12.68C15.65 12.88 16.06 13 16.5 13C16.94 13 17.35 12.88 17.71 12.68Z" fill="#323232" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_15181">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <span>{t("USERSETUP")}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <g clip-path="url(#clip0_1_15171)">
                    <path d="M9.99984 6L8.58984 7.41L13.1698 12L8.58984 16.59L9.99984 18L15.9998 12L9.99984 6Z" fill="#192739" fill-opacity="0.94" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_15171">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </Link>
            </p>
          </div>
          <div className='MACCOUNT__MENU__TWO'>
            <p onClick={() => setShowSettings(true)}>
              <Link>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <g clip-path="url(#clip0_1_15188)">
                    <path d="M19.4298 12.98C19.4698 12.66 19.4998 12.34 19.4998 12C19.4998 11.66 19.4698 11.34 19.4298 11.02L21.5398 9.37C21.7298 9.22 21.7798 8.95 21.6598 8.73L19.6598 5.27C19.5698 5.11 19.3998 5.02 19.2198 5.02C19.1598 5.02 19.0998 5.03 19.0498 5.05L16.5598 6.05C16.0398 5.65 15.4798 5.32 14.8698 5.07L14.4898 2.42C14.4598 2.18 14.2498 2 13.9998 2H9.99984C9.74984 2 9.53984 2.18 9.50984 2.42L9.12984 5.07C8.51984 5.32 7.95984 5.66 7.43984 6.05L4.94984 5.05C4.88984 5.03 4.82984 5.02 4.76984 5.02C4.59984 5.02 4.42984 5.11 4.33984 5.27L2.33984 8.73C2.20984 8.95 2.26984 9.22 2.45984 9.37L4.56984 11.02C4.52984 11.34 4.49984 11.67 4.49984 12C4.49984 12.33 4.52984 12.66 4.56984 12.98L2.45984 14.63C2.26984 14.78 2.21984 15.05 2.33984 15.27L4.33984 18.73C4.42984 18.89 4.59984 18.98 4.77984 18.98C4.83984 18.98 4.89984 18.97 4.94984 18.95L7.43984 17.95C7.95984 18.35 8.51984 18.68 9.12984 18.93L9.50984 21.58C9.53984 21.82 9.74984 22 9.99984 22H13.9998C14.2498 22 14.4598 21.82 14.4898 21.58L14.8698 18.93C15.4798 18.68 16.0398 18.34 16.5598 17.95L19.0498 18.95C19.1098 18.97 19.1698 18.98 19.2298 18.98C19.3998 18.98 19.5698 18.89 19.6598 18.73L21.6598 15.27C21.7798 15.05 21.7298 14.78 21.5398 14.63L19.4298 12.98ZM17.4498 11.27C17.4898 11.58 17.4998 11.79 17.4998 12C17.4998 12.21 17.4798 12.43 17.4498 12.73L17.3098 13.86L18.1998 14.56L19.2798 15.4L18.5798 16.61L17.3098 16.1L16.2698 15.68L15.3698 16.36C14.9398 16.68 14.5298 16.92 14.1198 17.09L13.0598 17.52L12.8998 18.65L12.6998 20H11.2998L11.1098 18.65L10.9498 17.52L9.88984 17.09C9.45984 16.91 9.05984 16.68 8.65984 16.38L7.74984 15.68L6.68984 16.11L5.41984 16.62L4.71984 15.41L5.79984 14.57L6.68984 13.87L6.54984 12.74C6.51984 12.43 6.49984 12.2 6.49984 12C6.49984 11.8 6.51984 11.57 6.54984 11.27L6.68984 10.14L5.79984 9.44L4.71984 8.6L5.41984 7.39L6.68984 7.9L7.72984 8.32L8.62984 7.64C9.05984 7.32 9.46984 7.08 9.87984 6.91L10.9398 6.48L11.0998 5.35L11.2998 4H12.6898L12.8798 5.35L13.0398 6.48L14.0998 6.91C14.5298 7.09 14.9298 7.32 15.3298 7.62L16.2398 8.32L17.2998 7.89L18.5698 7.38L19.2698 8.59L18.1998 9.44L17.3098 10.14L17.4498 11.27ZM11.9998 8C9.78984 8 7.99984 9.79 7.99984 12C7.99984 14.21 9.78984 16 11.9998 16C14.2098 16 15.9998 14.21 15.9998 12C15.9998 9.79 14.2098 8 11.9998 8ZM11.9998 14C10.8998 14 9.99984 13.1 9.99984 12C9.99984 10.9 10.8998 10 11.9998 10C13.0998 10 13.9998 10.9 13.9998 12C13.9998 13.1 13.0998 14 11.9998 14Z" fill="#323232" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_15188">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <span>{t("Setting")}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <g clip-path="url(#clip0_1_15171)">
                    <path d="M9.99984 6L8.58984 7.41L13.1698 12L8.58984 16.59L9.99984 18L15.9998 12L9.99984 6Z" fill="#192739" fill-opacity="0.94" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_15171">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </Link>
            </p>
            <p>
              <Link to={`/CMS/OurStory`}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <g clip-path="url(#clip0_1_15194)">
                    <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16ZM7 9H9V11H7V9ZM15 9H17V11H15V9ZM11 9H13V11H11V9Z" fill="#323232" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_15194">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <span>{t("ABOUTUS")}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <g clip-path="url(#clip0_1_15171)">
                    <path d="M9.99984 6L8.58984 7.41L13.1698 12L8.58984 16.59L9.99984 18L15.9998 12L9.99984 6Z" fill="#192739" fill-opacity="0.94" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_15171">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </Link>
            </p>
            {localStorage.getItem("device") !== 'true' && window.innerWidth < 912 && <p>
              <Link>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <g clip-path="url(#clip0_1_15200)">
                    <path d="M17.0002 15H19.0002V17H17.0002V15ZM17.0002 11H19.0002V13H17.0002V11ZM17.0002 7H19.0002V9H17.0002V7ZM13.7402 7L15.0002 7.84V7H13.7402Z" fill="#323232" />
                    <path d="M10 3V4.51L12 5.84V5H21V19H17V21H23V3H10Z" fill="#323232" />
                    <path d="M8.17 5.7002L15 10.2502V21.0002H1V10.4802L8.17 5.7002ZM10 19.0002H13V11.1602L8.17 8.0902L3 11.3802V19.0002H6V13.0002H10V19.0002Z" fill="#323232" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_15200">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <span>{t("SHOPPINGWITHUS")}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <g clip-path="url(#clip0_1_15171)">
                    <path d="M9.99984 6L8.58984 7.41L13.1698 12L8.58984 16.59L9.99984 18L15.9998 12L9.99984 6Z" fill="#192739" fill-opacity="0.94" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_15171">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </Link>
            </p>}
            <p>
              <Link>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
                  <path d="M19 9.22C19 3.73 14.74 0 10 0C5.31 0 1 3.65 1 9.28C0.4 9.62 0 10.26 0 11V13C0 14.1 0.9 15 2 15H3V8.9C3 5.03 6.13 1.9 10 1.9C13.87 1.9 17 5.03 17 8.9V16H9V18H17C18.1 18 19 17.1 19 16V14.78C19.59 14.47 20 13.86 20 13.14V10.84C20 10.14 19.59 9.53 19 9.22Z" fill="#323232" />
                  <path d="M7 11C7.55228 11 8 10.5523 8 10C8 9.44772 7.55228 9 7 9C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11Z" fill="#323232" />
                  <path d="M13 11C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9C12.4477 9 12 9.44772 12 10C12 10.5523 12.4477 11 13 11Z" fill="#323232" />
                  <path d="M16 8.03C15.52 5.18 13.04 3 10.05 3C7.01997 3 3.75997 5.51 4.01997 9.45C6.48997 8.44 8.34997 6.24 8.87997 3.56C10.19 6.19 12.88 8 16 8.03Z" fill="#323232" />
                </svg>
                <span>{t("Support")}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <g clip-path="url(#clip0_1_15171)">
                    <path d="M9.99984 6L8.58984 7.41L13.1698 12L8.58984 16.59L9.99984 18L15.9998 12L9.99984 6Z" fill="#192739" fill-opacity="0.94" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_15171">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </Link>
            </p>
          </div>
          <div className='MACCOUNT__MENU__THREE'>
            <p onClick={signout}>
              <Link>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
                  <path d="M9 4L7.6 5.4L10.2 8H0V10H10.2L7.6 12.6L9 14L14 9L9 4ZM18 16H10V18H18C19.1 18 20 17.1 20 16V2C20 0.9 19.1 0 18 0H10V2H18V16Z" fill="#323232" />
                </svg>
                <span>{t("SIGNOUT")}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <g clip-path="url(#clip0_1_15171)">
                    <path d="M9.99984 6L8.58984 7.41L13.1698 12L8.58984 16.59L9.99984 18L15.9998 12L9.99984 6Z" fill="#192739" fill-opacity="0.94" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_15171">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </Link>
            </p>
          </div>
        </div>
      </div>

  )
}

export default MAccount
